import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/**
 * DOVE-2451 — keep debug logging out of the production console.
 *
 * `console.warn` and `console.error` are deliberately left alive. The warns are real
 * diagnostics (failed module loads, unexpected API response shapes) and there are ~490
 * error handlers; with source maps now off in production, those are most of what makes an
 * issue diagnosable.
 *
 * Only `environment.prod.ts` sets `production: true`, so staging keeps its logs and stays
 * debuggable while it soaks the optimized build.
 *
 * Note this suppresses output only — arguments are still evaluated, so avoid
 * `console.log(expensiveThing())` on the assumption the work is skipped.
 */
if (environment.production) {
	console.log = () => {};
	console.debug = () => {};
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
